import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getDailySummary, updateUmpAvailableForGame } from '../actions/gamesActions';
import { getUmpInfo, assignUmpToGame, removeUmp } from '../actions/umpireActions';
import { getCoachesTeams } from '../actions/coachActions';
import { getSeasonDivisions } from '../actions/divisionsActions';
import DailySummary from '../components/DailySummaryV2';

const mapDispatchToProps = dispatch => ({
  getDailySummary: summaryDay => {
    dispatch(getDailySummary(summaryDay));
  },
  updateUmpAvailableForGame: (gameId, umpAvailable) => {
    dispatch(updateUmpAvailableForGame(gameId, umpAvailable));
  },
  getUmpInfo: memberId => {
    dispatch(getUmpInfo(memberId));
  },
  assignUmpToGame: (umpireId, gameId, plate) => {
    dispatch(assignUmpToGame(umpireId, gameId, plate));
  },
  removeUmp: (umpireId, gameId, plate) => {
    dispatch(removeUmp(umpireId, gameId, plate));
  },
  getCoachesTeams: (memberId, seasonId) => {
    dispatch(getCoachesTeams(memberId, seasonId));
  },
  getSeasonDivisions: (seasonId) => {
    dispatch(getSeasonDivisions(seasonId));
  },
});

const mapStateToProps = state => ({
  dailySummary: state.lists.dailySummary,
  fetchingDailySummary: state.lists.fetchingDailySummary,
  games: state.games.games,
  memberId: state.user.memberId,
  userType: state.user.userType,
  umpireLevel: state.user.umpireLevel,
  teamsCoaching: state.user.teamsCoaching,
  fetchingCoachTeamsStatus: state.user.fetchingCoachTeamsStatus,
  umpires: state.umpires.umpires,
  umpiresList: state.umpires.umpiresList,
  fetchingUmpiresStatus: state.umpires.fetchingStatus,
  userSeason: state.user.userSeason,
  seasons: state.seasons.seasons,
  seasonDivisions: state.divisions.seasonDivisions,
  seasonDivisionsList: state.divisions.seasonDivisionsList,
  fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
});

const DailySummaryContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(DailySummary));
export default DailySummaryContainer;



// WEBPACK FOOTER //
// ./src/containers/DailySummaryContainer.js